import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  MenuItem,
  Slide,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppLoader from "../../../components/AppLoader";
import GlobalButton from "../../../components/CustomButton";
import CustomDropDown from "../../../components/CutomDropDown";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import appcolors from "../../../constants/Colors";
import globalStyle from "../../../globalStyle";
import { setSearchKeys } from "../../../lib/slices/searchKeysSlice";
import { createNotification } from "../../../services/notificationApiFn";
import { handleOpenSnackBar } from "../../../utils";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-end",
  },
  "& .MuiPaper-root": {
    height: "100%",
    width: "100%",
    maxWidth: "500px",
    margin: 0,
    overflow: "visible !important",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "100% !important",
    },
  },
  "& .MuiDialog-icon-btn": {
    position: "absolute",
    top: "20px",
    left: "-55px",
    zIndex: 999,
    backgroundColor: appcolors.white,
    "&:hover": {
      backgroundColor: appcolors.white,
    },
    [theme.breakpoints.down("md")]: {
      top: 6,
      right: 6,
      left: "inherit",
    },
  },
  "& .dialogHeader-root": {
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(2),
  },
  "& .dialogSubHeader-root": {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  "& .dialogContent-root": {
    padding: "30px 40px",
  },
}));

let paramsData = {};

const userType = [
  {
    title: "All Suppliers",
    type: "supplier",
  },
  {
    title: "All Compnies",
    type: "company",
  },
  {
    title: "All Workers",
    type: "worker",
  },
  // {
  //   title: "All Education",
  //   type: "education",
  // },
  {
    title: "All Customers",
    type: "user",
  },
];

const PushNotificationDialog = forwardRef(({ }, ref) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(["notification"]);
  const [isLoading, setIsLoading] = useState(false);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);

  const [inputValues, setInputValues] = useState({
    type: "",
    title: "",
    body: "",
  });

  const [inputError, setInputError] = useState({
    type: false,
    title: false,
    body: false,
  });

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setInputValues({});
    setInputError({});
  };

  const handleChangeInputValues = (event) => {
    const { name, value } = event.target;
    setInputValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateNotification = async () => {
    try {
      let payload = {
        title: inputValues.title,
        body: inputValues.body,
        userType: inputValues.type,
        isResend: false,
        relatedTo: "pushed",
      };
      setIsLoading(true);
      const response = await createNotification(payload);
      if (response.data.status === "success") {
        handleOpenSnackBar("success", response.data.message);
        paramsData.getData("");
        handleClose();
        dispatch(
          setSearchKeys({
            ...searchKeys,
            notificationTitle: "",
          })
        );
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <BootstrapDialog
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        scroll="body"
      >
        <IconButton className="MuiDialog-icon-btn" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <Box className={"dialogHeader-root"}>
          <Typography
            variant="h1"
            fontSize={"1.125rem"}
            fontWeight={500}
            color={appcolors.white}
          >
            {t("createNewNotification")}
          </Typography>
          <Typography
            variant="body2"
            fontSize={"0.75rem"}
            fontWeight={300}
            color={appcolors.white}
          >
            {/* {moment(new Date()).format(s"DD/MM/YYYY dddd h:m a")} */}
          </Typography>
        </Box>
        <DialogContent>
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              <Label labelText={t("selectUserType")} required />
              <CustomDropDown
                name={"type"}
                value={inputValues.type}
                onChange={handleChangeInputValues}
              >
                <MenuItem value={"Select"} disabled></MenuItem>
                {userType.map((v, i) => (
                  <MenuItem value={v.type}>{v.title}</MenuItem>
                ))}
              </CustomDropDown>
            </Grid>
            <Grid item xs={12}>
              <Label labelText={t("title")} required htmlFor={"title"} />
              <TextInput
                id={"title"}
                required
                styleProps={globalStyle.textField}
                inputError={inputError.title}
                helperText={inputError.title && t("validation.titleRequired")}
                name={"title"}
                value={inputValues.title}
                onChange={handleChangeInputValues}
              />
            </Grid>
            <Grid item xs={12}>
              <Label labelText={t("body")} required htmlFor={"body"} />
              <TextInput
                id={"body"}
                rows={3}
                multiline
                required
                styleProps={globalStyle.textField}
                inputError={inputError.body}
                helperText={inputError.body && t("validation.bodyRequired")}
                name={"body"}
                value={inputValues.body}
                onChange={handleChangeInputValues}
              />
            </Grid>
          </Grid>

          <GlobalButton
            btnText={"sendNotification"}
            handleClickBtn={handleCreateNotification}
            styleProps={{
              mt: 4,
              height: 50,
            }}
          />
        </DialogContent>
      </BootstrapDialog>
    </>
  );
});

export default PushNotificationDialog;
